import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={30}
            height={31}
            viewBox="0 0 30 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M.588 10.417a12.52 12.52 0 019.33-9.329 22.256 22.256 0 0110.165 0 12.519 12.519 0 019.329 9.33 22.258 22.258 0 010 10.165 12.52 12.52 0 01-9.33 9.329 22.258 22.258 0 01-10.165 0 12.52 12.52 0 01-9.329-9.33 22.256 22.256 0 010-10.165z"
            fill={props.isHover ? '#B42318' : theme["#DCFFFD"]}
            fillOpacity={0.9}
        />
        <path
            d="M17.073 12.307l-3.51 3.51 3.51 3.51"
            stroke={props.isHover ? "#ffffff" : "#667085"}
            strokeWidth={1.66667}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        </svg>
    )
}

export default SvgComponent
